@if (notificationStyle === NotificationStyle.Error) {
  <rt-icon name="warning" class="warning-icon"></rt-icon>
}

@if (notificationStyle === NotificationStyle.Success) {
  <div class="success">
    <rt-icon name="check"></rt-icon>
  </div>
}

@if (notificationStyle === NotificationStyle.InProgress) {
  <div class="progress">
    <rt-spinner variant="small-x"></rt-spinner>
  </div>
}
